<div
  class="card card--five bg-white mg-btm-30 box-shadow-card p-24-18"
  style="margin-top: 50px"
>
  <div style="padding: 20px">
    <div class="form-title mg-top-20">
      <h4 class="u-medium t-align-initial f-16 r-show color-blue-light">
        Información Cónyuge
      </h4>
    </div>

    <div [formGroup]="formConyuge">
      <div class="row" style="margin-top: 20px">
        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="c-field mg-btm-30">
            <label
              aria-label="Seleccione tipo de documento de identidad"
              for="TipoIdConyuge"
              class="u-medium t-align-initial f-14 r-show color-blue-dark"
            >Tipo de documento</label
            >
            <div class="select-custom-mat">
              <select
                formControlName="TipoIdConyuge"
                id="TipoIdConyuge"
                aria-required="true"
                [ngClass]="{
                  hasError:
                    formConyuge?.get('TipoIdConyuge')?.errors &&
                    formConyuge?.get('TipoIdConyuge')?.touched
                }"
              >
                <option value="" disabled selected></option>
                <option
                  *ngFor="let tipoIdentificacion of tiposIdentificacion"
                  [value]="tipoIdentificacion.valor"
                >
                  {{ tipoIdentificacion.nombre }}
                </option>
              </select>
            </div>

            <app-form-errors
              *ngIf="formConyuge.get('TipoIdConyuge')?.touched"
              [errors]="formConyuge.get('TipoIdConyuge')?.errors"
            >
              Campo obligatorio
            </app-form-errors>
          </div>
        </div>

        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="c-field mg-btm-30">
            <label
              aria-label="Escriba número de documento de identidad"
              for="NumIdConyuge"
              class="u-medium t-align-initial f-14 r-show color-blue-dark"
            >Número de documento</label
            >
            <div class="c-field_cont c-field_cont--right">
              <input
                type="text"
                id="NumIdConyuge"
                formControlName="NumIdConyuge"
                aria-required="true"
                (blur)="obtenerSolicitudesDeCambioEstadoCivil(formConyuge?.get('TipoIdConyuge').value, $event.target.value)"
              />
              <em aria-hidden="true" class="material-icons material-icons-input"
              >subtitles</em
              >
            </div>
            <app-form-errors
              *ngIf="formConyuge.get('NumIdConyuge')?.touched"
              [errors]="formConyuge.get('NumIdConyuge')?.errors"
            >
              Campo obligatorio
            </app-form-errors>
          </div>
        </div>

        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="c-field mg-btm-30">
            <label
              for="GeneroConyuge"
              class="u-medium text-initial f-14 color-blue-dark"
              aria-hidden="true"
            >
              Genero</label
            >
            <div class="select-custom-mat">
              <select
                formControlName="GeneroConyuge"
                id="GeneroConyuge"
                aria-required="true"
              >
                <option value="" disabled selected></option>
                <option *ngFor="let genderC of genders" [value]="genderC.value">
                  {{ genderC.name }}
                </option>
              </select>
            </div>
            <div class="text-invalid">
              <app-form-errors
                *ngIf="formConyuge.get('GeneroConyuge')?.touched"
                [errors]="formConyuge.get('GeneroConyuge')?.errors"
              >
                Campo obligatorio
              </app-form-errors>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="c-field mg-btm-30">
            <label
              for="FechaNaciConyuge"
              class="u-medium text-initial f-14 color-blue-dark"
              aria-hidden="true"
            >
              Fecha de nacimiento
            </label>
            <div class="c-field_cont c-field_cont--right">
              <input
                type="date"
                [max]="maximaFecha | date : 'yyyy-MM-dd'"
                (focus)="showCalendar($event)"
                id="FechaNaciConyuge"
                formControlName="FechaNaciConyuge"
                aria-label="Seleccionar la fecha de nacimiento del cónyuge. Formato: Dia/Mes/Año"
              />
            </div>
            <app-form-errors
              *ngIf="formConyuge.get('FechaNaciConyuge')?.touched"
              [errors]="formConyuge.get('FechaNaciConyuge')?.errors"
            >
              Campo obligatorio
            </app-form-errors>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="c-field mg-btm-30">
            <label
              aria-label="Escriba primer apellido"
              for="Apellido1Conyuge"
              class="u-medium t-align-initial f-14 r-show color-blue-dark"
            >
              Primer Apellido</label
            >

            <div class="c-field_cont c-field_cont--right">
              <input
                type="text"
                class="u-uppercase"
                formControlName="Apellido1Conyuge"
                id="Apellido1Conyuge"
                aria-required="true"
              />
              <em aria-hidden="true" class="material-icons material-icons-input"
              >account_circle</em
              >
            </div>
            <app-form-errors
              *ngIf="formConyuge.get('Apellido1Conyuge')?.touched"
              [errors]="formConyuge.get('Apellido1Conyuge')?.errors"
            >
              Campo obligatorio
            </app-form-errors>
          </div>
        </div>

        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="c-field mg-btm-30">
            <label
              aria-label="Escriba segundo apellido"
              for="Apellido2Conyuge"
              class="u-medium t-align-initial f-14 r-show color-blue-dark"
            >Segundo Apellido (opcional)</label
            >
            <div class="c-field_cont c-field_cont--right">
              <input
                type="text"
                class="u-uppercase"
                formControlName="Apellido2Conyuge"
                id="Apellido2Conyuge"
                aria-required="true"
              />
              <em aria-hidden="true" class="material-icons material-icons-input"
              >account_circle</em
              >
            </div>

            <app-form-errors
              *ngIf="formConyuge.get('Apellido2Conyuge')?.touched"
              [errors]="formConyuge.get('Apellido2Conyuge')?.errors"
            >
              Campo obligatorio
            </app-form-errors>
          </div>
        </div>

        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="c-field mg-btm-30">
            <label
              aria-label="Escriba primer nombre"
              for="Nombre1Conyuge"
              class="u-medium t-align-initial f-14 r-show color-blue-dark"
            >Primer Nombre</label
            >
            <div class="c-field_cont c-field_cont--right">
              <input
                type="text"
                class="u-uppercase"
                formControlName="Nombre1Conyuge"
                id="Nombre1Conyuge"
                aria-required="true"
              />
              <em aria-hidden="true" class="material-icons material-icons-input"
              >account_circle</em
              >
            </div>
            <app-form-errors
              *ngIf="formConyuge.get('Nombre1Conyuge')?.touched"
              [errors]="formConyuge.get('Nombre1Conyuge')?.errors"
            >
              Campo obligatorio
            </app-form-errors>
          </div>
        </div>

        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="c-field mg-btm-30">
            <label
              aria-label="Escriba segundo nombre"
              for="Nombre2Conyuge"
              class="u-medium t-align-initial f-14 r-show color-blue-dark"
            >Segundo Nombre (opcional)</label
            >
            <div class="c-field_cont c-field_cont--right">
              <input
                id="Nombre2Conyuge"
                class="u-uppercase"
                type="text"
                formControlName="Nombre2Conyuge"
                aria-label="Escribir segundo nombre del cónyuge"
              />
              <em aria-hidden="true" class="material-icons material-icons-input"
              >account_circle</em
              >
            </div>
            <app-form-errors
              *ngIf="formConyuge.get('Nombre2Conyuge').touched"
              [errors]="formConyuge.get('Nombre2Conyuge').errors"
            >
              Campo obligatorio
            </app-form-errors>
          </div>
        </div>
      </div>
      <ng-container *ngIf="tieneInformacionAdicional">
        <div class="form-title mg-top-20">
          <h4 class="u-medium t-align-initial f-16 r-show color-blue-light">
            Información Laboral Cónyuge
          </h4>
        </div>

        <div class="row" style="margin-top: 20px">
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="c-field mg-btm-30">
              <label
                for="OcupacionConyuge"
                class="u-medium t-align-initial f-14 r-show color-blue-dark"
              >Ocupación</label
              >
              <div class="select-custom-mat">
                <select
                  formControlName="OcupacionConyuge"
                  id="OcupacionConyuge"
                  aria-required="true"
                >
                  <option value="" disabled selected></option>
                  <option
                    *ngFor="let occupation of occupations"
                    [value]="occupation.value"
                  >
                    {{ occupation.name }}
                  </option>
                </select>
              </div>
              <div class="text-invalid">
                <app-form-errors
                  *ngIf="formConyuge.get('OcupacionConyuge')?.touched"
                  [errors]="formConyuge.get('OcupacionConyuge')?.errors"
                >
                  Campo obligatorio
                </app-form-errors>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="c-field mg-btm-30">
              <label
                for="TipoIdEmpresaConyuge"
                class="u-medium text-initial f-14 color-blue-dark"
                aria-hidden="true"
              >
                Tipo Identificación Empresa
              </label>
              <div class="select-custom-mat">
                <select
                  formControlName="TipoIdEmpresaConyuge"
                  id="TipoIdEmpresaConyuge"
                  aria-required="true"
                >
                  <option value="" disabled selected></option>
                  <option
                    *ngFor="let documentCompany of documentCompanies"
                    [value]="documentCompany.value"
                  >
                    {{ documentCompany.name }}
                  </option>
                </select>
              </div>
              <div class="text-invalid">
                <app-form-errors
                  *ngIf="formConyuge.get('TipoIdEmpresaConyuge')?.touched"
                  [errors]="formConyuge.get('TipoIdEmpresaConyuge')?.errors"
                >
                  Campo obligatorio
                </app-form-errors>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="c-field mg-btm-30">
              <label
                aria-label="Escriba número de identidad empresa"
                for="NumIdEmpresaConyuge"
                class="u-medium t-align-initial f-14 r-show color-blue-dark"
              >Número Identificación Empresa</label
              >
              <div class="c-field_cont c-field_cont--right">
                <input
                  type="text"
                  formControlName="NumIdEmpresaConyuge"
                  id="NumIdEmpresaConyuge"
                  aria-required="true"
                  maxlength="9"
                  pattern="^\d{1,9}$"
                  (keypress)="onlyAllowNumbers($event)"
                />
                <em
                  aria-hidden="true"
                  class="material-icons material-icons-input"
                >account_circle</em
                >
              </div>
              <app-form-errors
                *ngIf="formConyuge.get('NumIdEmpresaConyuge')?.touched"
                [errors]="formConyuge.get('NumIdEmpresaConyuge')?.errors"
              >
                Campo obligatorio
              </app-form-errors>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="c-field mg-btm-30">
              <label
                aria-label="Escriba razon social"
                for="RazonEmpresaConyuge"
                class="u-medium t-align-initial f-14 r-show color-blue-dark"
              >Razón Social Empresa</label
              >
              <div class="c-field_cont c-field_cont--right">
                <input
                  type="text"
                  class="u-uppercase"
                  formControlName="RazonEmpresaConyuge"
                  id="RazonEmpresaConyuge"
                  aria-required="true"
                />
                <em
                  aria-hidden="true"
                  class="material-icons material-icons-input"
                >account_circle</em
                >
              </div>
              <app-form-errors
                *ngIf="formConyuge.get('RazonEmpresaConyuge')?.touched"
                [errors]="formConyuge.get('RazonEmpresaConyuge')?.errors"
              >
                Campo obligatorio
              </app-form-errors>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="c-field mg-btm-30">
              <label
                aria-label="Escriba salario"
                for="SalarioConyuge"
                class="u-medium t-align-initial f-14 r-show color-blue-dark"
              >Salario Básico</label
              >
              <div class="c-field_cont c-field_cont--right">
                <input
                  type="number"
                  formControlName="SalarioConyuge"
                  id="SalarioConyuge"
                  aria-required="true"
                />
                <em
                  aria-hidden="true"
                  class="material-icons material-icons-input"
                >attach_money</em
                >
              </div>
              <app-form-errors
                *ngIf="formConyuge.get('SalarioConyuge')?.touched"
                [errors]="formConyuge.get('SalarioConyuge')?.errors"
              >
                Campo obligatorio
              </app-form-errors>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="c-field mg-btm-30">
              <label
                for="TipoSalarioConyuge"
                class="u-medium text-initial f-14 color-blue-dark"
                aria-hidden="true"
              >
                Tipo de salario</label
              >
              <div class="select-custom-mat">
                <select
                  formControlName="TipoSalarioConyuge"
                  id="TipoSalarioConyuge"
                  aria-required="true"
                >
                  <option value="" disabled selected></option>
                  <option
                    *ngFor="let salary of salaryTypes"
                    [value]="salary.value"
                  >
                    {{ salary.name }}
                  </option>
                </select>
              </div>
              <div class="text-invalid">
                <app-form-errors
                  *ngIf="formConyuge.get('TipoSalarioConyuge')?.touched"
                  [errors]="formConyuge.get('TipoSalarioConyuge')?.errors"
                >
                  Campo obligatorio
                </app-form-errors>
              </div>
            </div>
          </div>

        </div>
      </ng-container>

      <ng-container
        *ngIf="tieneSeccionRadioButton"
        [formGroup]="formRadioButton"
      >
        <span class="mg-lft-10 u-regular color-blue-dark"
        >¿La Información presentada corresponde al cónyuge de tu
          empleado?</span
        >
        <ng-container *ngFor="let etiquetaRadioButton of etiquetasRadioButton">
          <label
            role="radio"
            tabindex="0"
            [for]="etiquetaRadioButton.id"
            class="d-inline-flex pdd-rht-30 pdd-btm-30"
          >
            <input
              #{{etiquetaRadioButton.id}}
              [id]="etiquetaRadioButton.id"
              appDebounceClick
              formControlName="esCorrectoConyuge"
              [attr.aria-label]="etiquetaRadioButton.texto"
              type="radio"
              [value]="etiquetaRadioButton.valor"
            />
            <span
              [attr.aria-hidden]="etiquetaRadioButton.ariaHidden"
              class="mg-lft-10 u-regular"
            >{{ etiquetaRadioButton.texto }}</span
            >
          </label>
        </ng-container>
      </ng-container>

      <div class="row" *ngIf="habilitarConyugeCuidador">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="c-field mg-btm-30">
            <label class="u-medium t-align-initial f-14 color-blue-dark">
              <input
                type="checkbox"
                formControlName="CuidadorConyuge"
                id="CuidadorConyuge"
                aria-label="¿El cónyuge es cuidador?"
              />
              <span class="mg-lft-10">¿El cónyuge es cuidador?</span>
            </label>
          </div>
        </div>
      </div>
      <ng-content></ng-content>
    </div>
  </div>
</div>

<app-modal-processing
  [title]="'Enviando datos'"
  [idModal]="idModal"
  [textDescription]="
    'Estamos enviando los datos. No cierre la página hasta que termine, esto puede tardar unos segundos.'
  "
>
</app-modal-processing>
